import type { Staff } from "@/lib/authv2/store";
import { isCompanyRevenueHidden } from "@/features/dashboard/lib/role";

// NOTE: No `reports.*` action exists in BE actions.go during Model A migration.
// Kept on role check. Revisit if BE adds report-specific policy.

// branch_manager/area_manager đọc báo cáo phạm vi mình (BranchScope cắt phía
// BE — decision 0036). QC cố ý không có: báo cáo là số tiền.
const READ = new Set(["admin", "director", "accounting", "manager", "branch_manager", "area_manager"]);

function role(staff: Staff | null): string {
  return (staff?.role ?? "").toLowerCase();
}

// Trưởng phòng chụp, trang điểm, hậu kỳ chỉ việc phòng mình — không xem báo
// cáo doanh thu (CEO chốt Q03 17/10/2026); máy chủ cũng đóng cửa
// /dashboard/report-analytics và /reports/brand-revenue với họ.
export function canReadReports(staff: Staff | null): boolean {
  return READ.has(role(staff)) && !isCompanyRevenueHidden(staff);
}
